import {
  B_FLOW_ID,
  C_B_FLOW_ID,
  C_FLOW_ID,
  C_PL_FLOW_ID,
  PL_B_FLOW_ID,
  PL_FLOW_ID,
  TRIPLE_FLOW_ID,
} from '../boilerplate/item-ids';

/**
 * Transformer that sets all completed flows in input state depending on item id. Also
 * it sets a proper color that is related to the flow that the user is currently completing.
 */
export default (kasko) => {
  kasko.addEventListener('route-changed', ({ previous }) => {
    const inputState = kasko.getState().input;
    const state = kasko.getState();

    if (inputState.item_id === null) {
      return;
    }

    // Updates only for "/common-summary" screen.
    const commonSummaryUpdate = {};

    if (inputState.item_id === C_FLOW_ID) {
      commonSummaryUpdate.contents_finished = true;

      kasko.dispatchEvent('set-form-input', {
        item_A: true,
        item_B: false,
        item_C: false,
        item_A_B: false,
        item_A_C: false,
        item_B_C: false,
        item_A_B_C: false,
      });
    }
    if (inputState.item_id === PL_FLOW_ID) {
      commonSummaryUpdate.private_liability_finished = true;

      kasko.dispatchEvent('set-form-input', {
        item_A: false,
        item_B: true,
        item_C: false,
        item_A_B: false,
        item_A_C: false,
        item_B_C: false,
        item_A_B_C: false,
      });
    }
    if (inputState.item_id === B_FLOW_ID) {
      commonSummaryUpdate.buildings_finished = true;

      kasko.dispatchEvent('set-form-input', {
        item_A: false,
        item_B: false,
        item_C: true,
        item_A_B: false,
        item_A_C: false,
        item_B_C: false,
        item_A_B_C: false,
      });
    }
    if (inputState.item_id === C_PL_FLOW_ID) {
      commonSummaryUpdate.contents_finished = true;
      commonSummaryUpdate.private_liability_finished = true;

      kasko.dispatchEvent('set-form-input', {
        item_A: false,
        item_B: false,
        item_C: false,
        item_A_B: true,
        item_A_C: false,
        item_B_C: false,
        item_A_B_C: false,
      });
    }
    if (inputState.item_id === C_B_FLOW_ID) {
      commonSummaryUpdate.contents_finished = true;
      commonSummaryUpdate.buildings_finished = true;

      kasko.dispatchEvent('set-form-input', {
        item_A: false,
        item_B: false,
        item_C: false,
        item_A_B: false,
        item_A_C: true,
        item_B_C: false,
        item_A_B_C: false,
      });
    }
    if (inputState.item_id === PL_B_FLOW_ID) {
      commonSummaryUpdate.private_liability_finished = true;
      commonSummaryUpdate.buildings_finished = true;

      kasko.dispatchEvent('set-form-input', {
        item_A: false,
        item_B: false,
        item_C: false,
        item_A_B: false,
        item_A_C: false,
        item_B_C: true,
        item_A_B_C: false,
      });
    }
    if (inputState.item_id === TRIPLE_FLOW_ID) {
      commonSummaryUpdate.contents_finished = true;
      commonSummaryUpdate.private_liability_finished = true;
      commonSummaryUpdate.buildings_finished = true;

      kasko.dispatchEvent('set-form-input', {
        item_A: false,
        item_B: false,
        item_C: false,
        item_A_B: false,
        item_A_C: false,
        item_B_C: false,
        item_A_B_C: true,
      });
    }
    if (
      state.route.state.url === '/buildings-start' ||
      state.route.state.url === '/buildings-summary' ||
      state.route.state.url === '/buildings-loading'
    ) {
      if (state.route.state.url === '/buildings-summary' && previous.path !== 'common-summary') {
        kasko.dispatchEvent('set-form-input', {
          buildings_finished: true,
        });
        kasko.dispatchEvent('set-state-input', {
          buildings_finished: true,
        });
      }
      kasko.dispatchEvent('set-form-input', {
        item_color: 'red',
      });
      kasko.dispatchEvent('set-state-input', {
        item_color: 'red',
      });
    }
    if (
      state.route.state.url === '/start' ||
      state.route.state.url === '/summary' ||
      state.route.state.url === '/loading'
    ) {
      if (state.route.state.url === '/summary' && previous.path !== 'common-summary') {
        kasko.dispatchEvent('set-form-input', {
          contents_finished: true,
        });
        kasko.dispatchEvent('set-state-input', {
          contents_finished: true,
        });
      }
      kasko.dispatchEvent('set-form-input', {
        item_color: 'blue',
      });
      kasko.dispatchEvent('set-state-input', {
        item_color: 'blue',
      });
    }

    if (
      state.route.state.url === '/private-liability-start' ||
      state.route.state.url === '/private-liability-summary' ||
      state.route.state.url === '/private-liability-loading'
    ) {
      if (
        state.route.state.url === '/private-liability-summary' &&
        previous.path !== 'common-summary'
      ) {
        kasko.dispatchEvent('set-form-input', {
          private_liability_finished: true,
        });
        kasko.dispatchEvent('set-state-input', {
          private_liability_finished: true,
        });
      }
      kasko.dispatchEvent('set-form-input', {
        item_color: 'orange',
      });
      kasko.dispatchEvent('set-state-input', {
        item_color: 'orange',
      });
    }

    if (state.route.state.url === '/common-summary' || state.route.state.url === '/access-pin') {
      kasko.dispatchEvent('set-form-input', {
        ...commonSummaryUpdate,
        item_color: 'black',
      });
      kasko.dispatchEvent('set-state-input', {
        ...commonSummaryUpdate,
        item_color: 'black',
      });
    }
  });
};
